import React from 'react';
import { Link } from 'react-router-dom';

const LEGAL_LINKS = [
  { slug: 'terms-of-service', label: 'Terms of Service' },
  { slug: 'privacy-policy', label: 'Privacy Policy' },
  { slug: 'cookie-policy', label: 'Cookies' },
  { slug: 'earnings-disclaimer', label: 'Earnings Disclaimer' },
  { slug: 'refund-policy', label: 'Refund Policy' },
  { slug: 'member-agreement', label: 'Member Agreement' },
];

export default function LegalFooter() {
  return (
    <footer className="border-t border-border bg-background/60 backdrop-blur-sm" data-testid="legal-footer">
      <div className="max-w-6xl mx-auto px-4 py-10">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6">
          <div>
            <p className="text-foreground font-playfair text-lg">WeMasterminds</p>
            <p className="text-xs text-muted-foreground mt-1">
              3829 Pennsylvania Ave SE · Washington, DC 20020 · USA
            </p>
            <a href="mailto:info@wemillionaires.com" className="text-xs text-gold hover:underline mt-1 inline-block">
              info@wemillionaires.com
            </a>
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {LEGAL_LINKS.map(l => (
              <Link
                key={l.slug}
                to={`/legal/${l.slug}`}
                className="text-xs uppercase tracking-widest text-muted-foreground hover:text-gold transition-colors"
                data-testid={`footer-link-${l.slug}`}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-border/60 flex flex-col sm:flex-row sm:justify-between gap-2 text-[11px] text-muted-foreground">
          <span>© {new Date().getFullYear()} WeMasterminds. All rights reserved.</span>
          <span className="italic">
            Income results vary. No earnings are guaranteed. See{' '}
            <Link to="/legal/earnings-disclaimer" className="text-gold hover:underline">
              Earnings Disclaimer
            </Link>.
          </span>
        </div>
      </div>
    </footer>
  );
}
